import { render, staticRenderFns } from "./ClaimStageTypeField.vue?vue&type=template&id=265c28d2"
import script from "./ClaimStageTypeField.vue?vue&type=script&lang=js"
export * from "./ClaimStageTypeField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports